export const isTouchDevice = () =>
  typeof window !== 'undefined' &&
  Boolean(window.matchMedia?.('(pointer: coarse)').matches);
